var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.adVisible),expression:"adVisible"}],staticClass:"adBox pyun-banner-ad",attrs:{"id":_vm.containerId}})
}
var staticRenderFns = []

export { render, staticRenderFns }